import { RouteLocationRaw } from 'vue-router';
import { ProductComplete, ProductIdentity } from '../types/models';

export const buildIdentity = (product: ProductComplete): ProductIdentity => {
  const { sku, handle, categoryDetails } = product.attributes;

  if (!categoryDetails) {
    return {
      sku,
      handle,
      containerType: 'bundle',
    };
  }

  const identity: ProductIdentity = {
    sku,
    handle,
    containerType: categoryDetails.primaryCategory,
  };

  if (categoryDetails.type && categoryDetails.typeValue) {
    identity.specifier = {
      type: categoryDetails.type,
      value: categoryDetails.typeValue,
    };
  }
  return identity;
};

// A parent product is a product container (like toothpaste / lipbalm) with no specific flavour/colour. It groups the shoppable products
export const isParentProduct = (product: ProductComplete): boolean => {
  if (!product.attributes.identity) return false;
  return !product.attributes.identity.specifier;
};

export const stripParentHandle = (childSlug: string, parentHandle: string): string => {
  if (childSlug.startsWith(`${parentHandle}-`)) return childSlug.slice(parentHandle.length + 1);
  if (childSlug.endsWith(`-${parentHandle}`)) return childSlug.slice(0, -(parentHandle.length + 1));
  return childSlug;
};

export const buildProductRoute = (
  product: ProductComplete,
  variantHandle: string,
): RouteLocationRaw => {
  if (isParentProduct(product)) {
    const { handle } = product.attributes.identity;
    if (!variantHandle) {
      return { name: 'product', params: { handle } };
    }
    return {
      name: 'product-contextual',
      params: {
        parentHandle: handle,
        childHandle: stripParentHandle(variantHandle, handle),
      },
    };
  }

  return {
    name: 'product',
    params: {
      handle: variantHandle,
    },
  };
};
